import { render, staticRenderFns } from "./RolesSettings.vue?vue&type=template&id=51a3e48e&scoped=true&"
import script from "./RolesSettings.vue?vue&type=script&lang=ts&"
export * from "./RolesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RolesSettings.vue?vue&type=style&index=0&id=51a3e48e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a3e48e",
  null
  
)

export default component.exports